import React, { Component } from 'react';
import Hero from "../modules/Hero/Hero";
import FiveColumn from "../modules/FiveColumn/FiveColumn";
import ThreeColumnIcons from "../modules/ThreeColumnIcons/ThreeColumnIcons";
import RegisterBlock from "../modules/RegisterBlock";
import globals from '../globals';
import HelmetDefault from "../layout/HelmetDefault";
import PriceCheckerForm from "../forms/PriceCheckerForm/PriceCheckerForm";

class InternetOverview extends Component {

    constructor(props) {
        super(props);

        this.state = {
            title: '',
            leadCopy: [],
            fiveColumn: {},
            threeColumnIcons: {},
            seoTitle: '',
            seoDescription: '',
			form: {},
            dataReceived: false
        };
    }

    componentDidMount() {
        this.getData();
    }

    getData() {
        fetch('/api/internet/overview')
            .then(result => result.json())
            .then((result) => {
                this.setState(result);
                this.setDataReceived();
                globals.animatePageIn(this.container);
            });
    }

    setDataReceived() {
        this.setState({
            dataReceived: true
        });
    }

    render() {
        return (
            <div ref={(el) => this.container = el} style={{opacity: 0}}>
                <HelmetDefault {...this.state} />
                <Hero title={this.state.title} leadCopy={this.state.leadCopy} dataReceived={this.state.dataReceived} />
                <PriceCheckerForm
					title={this.state.form.title}
					subTitle={this.state.form.subTitle}
					speeds={[20, 50, 100, 200, 500, 1000]}
					submitFormUrl="/api/submit-price-checker-form/priceChecker"
					getPricingUrl="/api/get-fibre-pricing"
                    eventNameSpeed="businessFibreGlobalFormSpeed"
                    eventNameSubmit="businessFibreGlobalFormSubmit"
				/>
                <FiveColumn data={this.state.fiveColumn} />
                <ThreeColumnIcons data={this.state.threeColumnIcons} dataReceived={this.state.dataReceived} />
                <RegisterBlock />
            </div>
        );
    }

}

export default InternetOverview;


// WEBPACK FOOTER //
// ./resources/assets/js/internet/InternetOverview.js